import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchMyQuestionnaireRequests } from '@/api/questionnaires';
import type { MyQuestionnaireRequestsListParams } from '../-types';
import { buildMyRequestsFilterJson } from '../-utils/listParams';

export const myRequestsKeys = {
  all: ['questionnaires', 'my-requests'] as const,
  list: (params: MyQuestionnaireRequestsListParams) =>
    [...myRequestsKeys.all, 'list', params] as const,
};

function buildQs(params: MyQuestionnaireRequestsListParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(params.count));
  qs.set('filter', buildMyRequestsFilterJson(params));
  if (params.sort) qs.set('sort', params.sort);
  return qs.toString();
}

export function myRequestsQueryOptions(
  params: MyQuestionnaireRequestsListParams,
) {
  return queryOptions({
    queryKey: myRequestsKeys.list(params),
    queryFn: () => fetchMyQuestionnaireRequests(buildQs(params)),
  });
}

export function useMyRequestsQuery(params: MyQuestionnaireRequestsListParams) {
  return useQuery(myRequestsQueryOptions(params));
}
